// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorContainer__YqqN8MwcEU {
  width: 100%;
  display: flex;
  margin-top: 20%;
  align-items: center;
  flex-direction: column;
}
.errorContainer__YqqN8MwcEU .title__qx9hBii8Fe {
  margin: 30px auto 10px;
  font-weight: 500;
  font-size: 28px;
}
.errorContainer__YqqN8MwcEU .button__DLO2dVKifF {
  width: auto;
  padding: 0 10px;
  height: 30px;
  color: #fff;
  margin-top: 20px;
  line-height: 30px;
  border-radius: 4px;
  text-align: center;
  background: #04cb94;
}
.errorContainer__YqqN8MwcEU .button__DLO2dVKifF :hover {
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/components/Error404/index.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AACF;AANA;EAOI,sBAAA;EACA,gBAAA;EACA,eAAA;AAEJ;AAXA;EAYI,WAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAEJ;AAtBA;EAsBM,+CAAA;AAGN","sourcesContent":[".errorContainer {\n  width: 100%;\n  display: flex;\n  margin-top: 20%;\n  align-items: center;\n  flex-direction: column;\n  .title {\n    margin: 30px auto 10px;\n    font-weight: 500;\n    font-size: 28px;\n  }\n  .button {\n    width: auto;\n    padding: 0 10px;\n    height: 30px;\n    color: #fff;\n    margin-top: 20px;\n    line-height: 30px;\n    border-radius: 4px;\n    text-align: center;\n    background: #04cb94;\n    :hover {\n      box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.15);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorContainer": `errorContainer__YqqN8MwcEU`,
	"title": `title__qx9hBii8Fe`,
	"button": `button__DLO2dVKifF`
};
export default ___CSS_LOADER_EXPORT___;
